import Rest from '../Rest'

export default class FederationUnitService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/federation_units'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }
}
